import { memo } from 'react';
import { MemberInfoTemplate } from 'components/templates/MemberInfoTemplate';

type Props = {};

export const MemberInfo = memo((_props: Props) => {
	return <MemberInfoTemplate />;
});
